export default function BtnHamburger($DOM, classes) {
	$('.btn-menu').click(event => {
		event.preventDefault();
		
		$DOM.bodyTag.toggleClass(classes.ShowNavMain);
	});	
}